var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReverseLeadsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.33318C11.6825 1.33318 14.6667 4.31836 14.6667 7.99984C14.6667 11.6813 11.6825 14.6665 8 14.6665",
    stroke: "#686C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9987 14.3332C5.20645 14.0634 4.46224 13.6736 3.81404 13.164M3.81404 2.83574C4.46224 2.33357 5.20645 1.93633 5.9987 1.66651M5.9987 1.66651L4.66536 1.33318M5.9987 1.66651L5.66536 2.99984M1.33203 6.83058C1.47608 6.0586 1.77216 5.30908 2.19628 4.62703M1.33203 9.16911C1.47608 9.94111 1.77216 10.6906 2.19628 11.3726",
    stroke: "#686C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6C10 4.89543 9.1046 4 8 4C6.8954 4 6 4.89543 6 6C6 7.1046 6.8954 8 8 8C9.1046 8 10 7.1046 10 6Z",
    stroke: "#686C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3346 11.3333C11.3346 9.4924 9.84224 8 8.0013 8C6.16036 8 4.66797 9.4924 4.66797 11.3333",
    stroke: "#686C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReverseLeadsIcon);
export default __webpack_public_path__ + "static/media/reverseLeadsIcon.5c2235772e90ca53d2d8f9710a5ea0d3.svg";
export { ForwardRef as ReactComponent };